



























































import Vue from 'vue'
import Nav from '@/components/Nav.vue'
import { ApiResponse, Pagination, Sale } from '@/interfaces'
import { mapState } from 'vuex'
import QuickNav from '@/components/QuickNav.vue'
import SalesTable from '@/components/SalesTable.vue'

interface Parameter {
  search?: string | null
  page?: string | null
}

export default Vue.extend({
  components: { Nav, QuickNav, SalesTable },
  data() {
    return {
      sales: [] as Sale[],
      search: '',
      page: '1',
      activePage: 1,
      itemsTotal: 0,
      numPages: 1,
      orderBy: null as null | string,
      order: null as null | string,
      busy: false,
    }
  },
  computed: {
    ...mapState(['user', 'scrollPosition']),
  },
  mounted() {
    if (this.$route.query.search && this.$route.query.search !== null && this.$route.query.search !== '') {
      this.search = this.$route.query.search as string
    }

    if (this.$route.query.page) {
      this.page = this.$route.query.page as string
    }

    if (this.$route.query.search) {
      this.search = this.$route.query.search as string
    }

    if (this.$route.query.orderby) {
      this.orderBy = this.$route.query.orderby as string
    }

    if (this.$route.query.order) {
      this.order = this.$route.query.order as string
    }

    this.getSales()
  },
  methods: {
    updateRoute(resetPage = false) {
      if (resetPage) {
        this.page = '1'
      }

      // Setting query URL
      const query = {
        search: this.search,
        page: this.page,
        orderby: this.orderBy,
        order: this.order,
      }

      this.$router.push({ query: Object.assign({}, this.$route.query, query) }).catch(() => {
        // This empty catch method is here to avoid the "Avoided redundant navigation" error
      })
    },
    changePage(page: string) {
      this.page = page
      this.updateRoute()
    },
    getSales() {
      if (!this.busy) {
        this.busy = true
        this.sales = [] as Sale[]

        const params = {} as Parameter
        if (this.search) {
          params.search = this.search
        } else {
          delete params.search
        }

        // Setting query URL
        this.$router
          .push({
            query: Object.assign({}, this.$route.query, params),
          })
          .catch(() => {
            // This empty catch method is here to avoid the "Avoided redundant navigation" error
          })

        const loading = this.$loading({
          target: '#salesTable',
          text: 'Chargement des données...',
        })

        this.$api
          .get('/sales', {
            params: {
              search: this.search,
              page: this.page,
              orderby: 'startDate',
              order: 'DESC',
            },
          })
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            this.sales = apiResponse.data.sales

            const pagination = apiResponse.data.pagination as Pagination

            this.activePage = pagination.current
            this.itemsTotal = pagination.totalCount
            this.numPages = pagination.pageCount
          })
          .finally(() => {
            loading.close()
            this.busy = false

            // Automatically scroll to stored scroll position
            window.setTimeout(() => {
              window.scrollTo({ top: parseInt(this.scrollPosition) })
            }, 400)
          })
      }
    },
  },
})
